import { Component, EventEmitter, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { USER_TYPE } from 'src/app/core/Constants/static';
import { UserDetails, UserProfile } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';

@Component({
  selector: 'app-provider-listing',
  templateUrl: './provider-listing.component.html',
  styleUrls: ['./provider-listing.component.css']
})
export class ProviderListingComponent implements OnInit {
  isAddProvider: boolean = false;
  page_no: number = 1;
  providerList: any[] = [];
  page_limit: number = 10;
  totalCount!: number;
  filterForm!: FormGroup;
  providerId!: number | null;
  sortParams: any;
  showNavigation: boolean = true;
  showDetails: boolean = false;
  @Output() focus: EventEmitter<boolean> = new EventEmitter<boolean>();

  columnSort: any = {
    providerName: {
      sortType: 'ascending',
      clicked: true
    },
    providerCode: {
      sortType: 'ascending',
      clicked: true
    },
    providerId: {
      sortType: 'ascending',
      clicked: true
    },
    providerType: {
      sortType: 'ascending',
      clicked: true
    },
    area: {
      sortType: 'ascending',
      clicked: true
    },
    regulatoryAuthorityCode: {
      sortType: 'ascending',
      clicked: true
    },
    isActive: {
      sortType: 'ascending',
      clicked: true
    },
  };
  provType = [
    {
      id: '1',
      name: 'Hospitals'
    },
    {
      id: '2',
      name: 'Clinics'
    },
    {
      id: '3',
      name: 'Pharmacies'
    },
    {
      id: '4',
      name: 'Laboratories'
    },
    {
      id: '5',
      name: 'Radiology centers'
    }
  ];
  status = [{
    id: '2',
    name: 'InActive'
  },
  {
    id: '1',
    name: 'Active'
  }];
  Area = [{ id: '1', name: 'option1' }, { id: '2', name: 'option2' }];
  showFilter: boolean = true;
  user: UserProfile | null;
  isViewProvider: boolean = false;
  permissionNames:string[] =['addProvider']
  constructor(
    private provPayerApiService: ProvPayerApiService,
    private toasterandloader: ToasterService,
    private userService: UserService
  ) {
    this.user = this.userService.getUserInfo();
    this.permissionNames=this.user?.userDetails?.permissions ?this.user?.userDetails?.permissions:[]
  }

  ngOnInit(): void {
    // this.showFilterForm();
    this.createFilterForm();
    this.sortDropDown();
    
  }
  /**
   * Desc: to drop the array displaying in the dropdown
   */
  sortDropDown() {
    this.provType.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    this.status.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
  public showFilterForm() {
    if (this.user?.userDetails?.userType === USER_TYPE.payer || this.user?.userDetails?.userType === USER_TYPE.provider) {
      this.showFilter = false;
    } else {
      this.showFilter = true;
    }
  }
  createFilterForm() {
    this.filterForm = new FormGroup({
      providerId: new FormControl(null),
      provType: new FormControl(null),
      status: new FormControl(null),
      providerName: new FormControl(null),
      area: new FormControl(null),
    }, CustomValidation.formNotNull);
  }
  isOpen() {
    this.isAddProvider = true;
  }
  selectedValue(event: any, formElem: string) {
    if (!event) {
      this.filterForm.controls[formElem].patchValue(null);
    }
    this.filterForm.controls[formElem].patchValue(event);
  }
  applyFilter() {
      this.toasterandloader.isLoaderEnable(true);
      let payLoad = {
        per_page: this.page_limit,
        page: this.page_no,
        sort: this.sortParams,
        providerId: this.filterForm?.value?.providerId ? this.filterForm?.value?.providerId.trim() : '',
        providerType: this.filterForm?.value?.provType ? this.filterForm?.value?.provType : '',
        status: this.filterForm?.value?.status ? this.filterForm?.value?.status : '',
        providerArea: this.filterForm?.value?.area ? this.filterForm?.value?.area : '',
        providerName: this.filterForm?.value?.providerName ? this.filterForm?.value?.providerName.trim() : '',
      }
      if (this.user?.userDetails?.userType === USER_TYPE.provider && this.checkPermission('getProviderAccount')) {
        let id = this.user?.userDetails?.providerId
        this.provPayerApiService.getProviderListByProvider(id, payLoad).subscribe({
          next: (response) => {
            if (response) {
              this.providerList = response?.data?.data;
              if (this.providerList.length && response?.data?.total > 10) {
                this.showNavigation = true;
              } else {
                this.showNavigation = false;
              }
              this.totalCount = response?.data?.total;
              this.toasterandloader.isLoaderEnable(false);
            }
          },
          error: (error) => {
            this.toasterandloader.isLoaderEnable(false);
          },
        })
      } else if(this.checkPermission('getProvider')) {
        this.provPayerApiService.getProviderList(payLoad).subscribe({
          next: (response) => {
  
            if (response) {
              this.providerList = response?.data?.data;
              if (this.providerList.length && response?.data?.total > 10) {
                this.showNavigation = true;
              } else {
                this.showNavigation = false;
              }
              this.totalCount = response?.data?.total;
              this.toasterandloader.isLoaderEnable(false);
            }
          },
          error: (error) => {
            this.toasterandloader.isLoaderEnable(false);
          },
        });
      }
  }
  manageEdit() {
    this.isAddProvider = true;
    this.isViewProvider = false;
  }
  sortColumn(colName: string) {

    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        const element = this.columnSort[key];
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.applyFilter();
        }else{
          this.columnSort[key].sortType = 'ascending';
        }

      }
    }
  }
  applyFilterOnClick() {
    this.page_no = 1;
    if (
      Object.keys(this.filterForm.value).some(
        (k) => !!this.filterForm.value[k]?.length
      )
    ) {
      this.applyFilter();
    } else {
      this.toasterandloader.alert.toast({
        title: 'Info',
        type: 'info',
        message: 'Please select any one of the filter'
      })
    }

  }
  resetForm() {
    this.filterForm.reset();
    this.applyFilter();

    // if (
    //   Object.keys(this.filterForm.value).some(
    //     (k) => !!this.filterForm.value[k]?.length
    //   )
    // ) {
    //   this.filterForm.reset();
    //   this.applyFilter();
    // } else {
    //   this.toasterandloader.alert.toast({
    //     title: 'Info',
    //     type: 'info',
    //     message: 'There is no filter to reset'
    //   })
    // }

  }

  currentPageDetail(event?: any) {

    if (event) {
      this.page_no = event?.button_no;
      this.page_limit = event?.item_per_page;
    }
    this.focus.emit(true);
    this.applyFilter();
    if (this.providerList.length) this.showNavigation = true;

  }
  showEditPopup(id: number | null) {
    this.providerId = id;
    this.isAddProvider = true;
    this.showDetails = false;

  }
  showDetailsPopup(id: number | null) {
    this.providerId = id;
    this.isViewProvider = true;
    this.showDetails = true;
  }
  closePopup() {
    this.filterForm.reset();
    this.applyFilter();
  }
  checkPermission(perName:string):boolean{
    return this.userService.getPermissions(perName);
  }
}
